import React, {useContext, useEffect, useState} from 'react'
import s from './SideBar.module.scss'
import textLogo from 'Static/Logo/nxstep-white.svg';
import {clearSessionCookie, isEmployer, isLoggedIn, isMentee, isMentor, SessionContext} from 'Utils/sessions'
import {
    RiBriefcase2Line,
    RiCalendar2Fill,
    RiCompassDiscoverLine,
    RiDashboardFill,
    RiFirstAidKitFill,
    RiGiftLine,
    RiLoginBoxLine,
    RiLogoutBoxLine,
    RiMailFill,
    RiMoneyDollarCircleFill,
    RiSettings3Line,
    RiUser3Line
} from 'react-icons/ri';
import {AiOutlineForm, AiOutlineMenu} from 'react-icons/ai';
import {Root} from 'Root'
import {SidebarItem} from 'react-responsive-sidebar';
import {SearchBar} from 'Components/Input/Search'
import Notifications from './Notifications'
import avi from 'Static/default-avi.png';
import {isAmbassador} from "../../Utils/sessions";
import Button from "react-bootstrap/Button";

const UnreadMessageIndicator = ({}) => {
    const {session} = useContext(SessionContext);
    const [notifs, setNotifs] = useState(null)

    useEffect(() => {
        if (isLoggedIn()) {
            Root.miscApi.getUnreadMessageCount(session.jwt)
                .then((rsp) => {
                    if (typeof rsp.data === 'number' && !Number.isNaN(rsp.data) && rsp.data > 0) {
                        setNotifs(rsp.data)
                    } else {
                        setNotifs(null)
                    }
                })
                .catch((err) => {
                    setNotifs(null)
                })
        }
    }, []);

    useEffect(() => {
        if (isLoggedIn()) {
            navigator.serviceWorker.addEventListener('message', event => {
                if (event.data.type === 'notification-received') {
                    Root.miscApi.getUnreadMessageCount(session.jwt)
                        .then((rsp) => {
                            if (typeof rsp.data === 'number' && !Number.isNaN(rsp.data) && rsp.data > 0) {
                                setNotifs(rsp.data)
                            } else {
                                setNotifs(null)
                            }
                        })
                        .catch((err) => {
                            setNotifs(null)
                        })
                }
            });

            return () => {
                navigator.serviceWorker.removeEventListener('message', handleMessage);
            };
        }
    }, []);

    useEffect(() => {
        if (isLoggedIn()) {
            document.addEventListener('new-notification-received', (event) => {
                Root.miscApi.getUnreadMessageCount(session.jwt)
                    .then((rsp) => {
                        if (typeof rsp.data === 'number' && !Number.isNaN(rsp.data) && rsp.data > 0) {
                            setNotifs(rsp.data)
                        } else {
                            setNotifs(null)
                        }
                    })
                    .catch((err) => {
                        setNotifs(null)
                    })
            });

            document.addEventListener('thread-marked-read', (event) => {
                Root.miscApi.getUnreadMessageCount(session.jwt)
                    .then((rsp) => {
                        if (typeof rsp.data === 'number' && !Number.isNaN(rsp.data) && rsp.data > 0) {
                            setNotifs(rsp.data)
                        } else {
                            setNotifs(null)
                        }
                    })
                    .catch((err) => {
                        setNotifs(null)
                    })
            });
        }
    }, []);

    const handleMessage = (event) => {
        if (event.data.type === 'push-received') {
            console.log('Message from service worker:', event.data.message);
            // Perform actions in your app based on the message
            alert(event.data.message)
        }
    }

    return <>
        {notifs && <span className={'ms-2'}>({notifs})</span>}
    </>
}

const Header = ({
                    leftNav,
                    isScrolled,
                    title,
                    placeholder,
                    onMenuClick,
                    search = true,
                    searchBarSuggestions,
                    onSearchQueryChange,
                    onSearch
                }) => {
    const {session} = useContext(SessionContext);

    const redirectProfile = () => {
        window.location.href = "/profile"
    }

    function handleMenuClick() {
        if (onMenuClick) {
            onMenuClick()
        }
    }

    return <>
        <div className={`${s.invisibleHeader} ${isScrolled ? s.invisibleHeaderScrolled : ''}`}>
            {leftNav &&
                <>
                    {leftNav}
                </>
            }
            <div></div>
            <div className={`${s.revealSidebarButtonContainer}`}>
                <Button className={`btnLink`} onClick={handleMenuClick}><AiOutlineMenu color={'black'}
                                                                                       size={28}/></Button>
            </div>

            <div className={s.searchContainer}>
                {search && <SearchBar placeholder={placeholder || 'Search...'}
                                      suggestions={searchBarSuggestions} onQueryChange={onSearchQueryChange}
                                      onSearch={onSearch}/>}
            </div>

            {session.jwt && !isAmbassador() && <span className={`d-flex align-content-center justify-content-end`}>
            <Notifications className={s.notifications}/>
            <span className={`${s.profile}`} onClick={redirectProfile}>
                <div className={s.profileAvatar}
                     style={{backgroundImage: `url(${session.photo || avi})`, backgroundSize: 'cover'}}/>
                {/*<div className='ms-2 trunc'>*/}
                {/*    <span><strong>{session.firstName} {session.lastName}</strong></span>*/}
                {/*    <span className='text-muted d-block'>@{session.userName}</span>*/}
                {/*</div>*/}
            </span>
        </span>}
        </div>
    </>
}

const SideBarContainer = ({
                              leftNav,
                              session,
                              title,
                              search = true,
                              placeholder,
                              searchBarSuggestions,
                              onSearchQueryChange,
                              onSearch,
                              ...props
                          }) => {
    const [sidebarShown, setSidebarShown] = useState(false)
    // State to store the scrolled status
    const [isScrolled, setIsScrolled] = useState(false);

    const items = [
        <SidebarItem href={isEmployer(session) ? '/dashboard/employer' : '/dashboard'}><img
            alt=""
            src={textLogo}
            height="35"
            className="d-inline-block align-center"
        /></SidebarItem>,
    ]

    if (!isLoggedIn()) {
        items.push(
            <SidebarItem href='/discover'><span
                className={s.link}><RiCompassDiscoverLine/>{' '}Discover</span></SidebarItem>,
            <SidebarItem href='/blogs'><span className={s.link}><RiBriefcase2Line/>{' '}Blogs</span></SidebarItem>,
            <SidebarItem href='/register'><span className={s.link}><AiOutlineForm/>{' '}Register</span></SidebarItem>,
            <SidebarItem href='/login'><span className={s.link}><RiLoginBoxLine/>{' '}Login</span></SidebarItem>,
        )
    }

    if (session && session.jwt && isMentor(session)) {
        items.push(
            <SidebarItem href='/dashboard'><span
                className={s.link}><RiDashboardFill/>{' '}Dashboard</span></SidebarItem>,
            <SidebarItem href='/schedule'><span
                className={s.link}><RiCalendar2Fill/> {' '}Schedule</span></SidebarItem>,
            <SidebarItem href='/inbox'><span className={s.link}><RiMailFill/>{' '}Inbox<UnreadMessageIndicator/></span></SidebarItem>,
            <SidebarItem href='/invites'><span
                className={s.link}><RiGiftLine/>{' '}Invite {isMentor(session) ? 'Mentors' : 'Students'}</span></SidebarItem>,
            // <SidebarItem href='/payment'><span
            //     className={s.link}><RiMoneyDollarCircleFill/>{' '}Payment</span></SidebarItem>,
            <SidebarItem href='/settings'><span className={s.link}><RiSettings3Line/>{' '}Settings</span></SidebarItem>,
            <SidebarItem href='/support'><span className={s.link}><RiFirstAidKitFill/>{' '}Support</span></SidebarItem>,
            <SidebarItem href='/profile'><span className={s.link}><RiUser3Line/>{' '}Profile</span></SidebarItem>)
    }

    if (session && session.jwt && isMentee(session)) {
        items.push(
            <SidebarItem href='/dashboard'><span
                className={s.link}><RiDashboardFill/>{' '}Dashboard</span></SidebarItem>,
            <SidebarItem href='/discover'><span
                className={s.link}><RiCompassDiscoverLine/>{' '}Discover</span></SidebarItem>,
            <SidebarItem href='/schedule'><span
                className={s.link}><RiCalendar2Fill/> {' '}Schedule</span></SidebarItem>,
            <SidebarItem href='/inbox'><span className={s.link}><RiMailFill/>{' '}Inbox<UnreadMessageIndicator/></span></SidebarItem>,
            <SidebarItem href='/invites'><span
                className={s.link}><RiGiftLine/>{' '}Invite {isMentor(session) ? 'Mentors' : 'Students'}</span></SidebarItem>,
            // <SidebarItem href='/payment'><span
            //     className={s.link}><RiMoneyDollarCircleFill/>{' '}Payment</span></SidebarItem>,
            <SidebarItem href='/settings'><span className={s.link}><RiSettings3Line/>{' '}Settings</span></SidebarItem>,
            <SidebarItem href='/support'><span className={s.link}><RiFirstAidKitFill/>{' '}Support</span></SidebarItem>,
            <SidebarItem href='/profile'><span className={s.link}><RiUser3Line/>{' '}Profile</span></SidebarItem>)
    }

    function toggleSidebar() {
        setSidebarShown(!sidebarShown)
    }

    function handleScroll(e) {
        if (e.target?.scrollTop > 5) {
            setIsScrolled(true);
        } else {
            setIsScrolled(false);
        }
    }

    return <div className={s.appContent}>
        <aside className={s.mobileSidebar}>
            <div className={`${s.sidebarOverlay}`} style={{display: sidebarShown ? 'block' : 'none'}}
                 onClick={toggleSidebar}/>
            <div className={`${s.sideBar} ${sidebarShown ? s.show : ''}`}>
                <div className={s.sideBarOptions}>
                    {items && items.map((item, idx) => (
                        <div key={idx} style={{color: 'white', fontSize: '16px'}}>
                            {item}
                        </div>
                    ))}
                </div>
                {isLoggedIn &&
                    <div className={s.logoutButtonContainer}>
                        <div style={{color: 'white',  fontSize: '16px'}}>
                            <SidebarItem><span onClick={() => {
                                clearSessionCookie();
                                window.location.href = '/login'
                            }} className={s.link}><RiLogoutBoxLine/>{' '}Logout</span></SidebarItem>
                        </div>
                    </div>
                }
            </div>
        </aside>
        <aside className={s.desktopSidebar}>
            <div className={s.sideBar}>
                <div className={s.sideBarOptions}>
                    {items && items.map((item, idx) => (
                        <div key={idx} style={{color: 'white', fontSize: '16px'}}>
                            {item}
                        </div>
                    ))}
                </div>
                {isLoggedIn &&
                    <div className={s.logoutButtonContainer}>
                        <div style={{color: 'white', fontSize: '16px'}}>
                            <SidebarItem>
                                <span onClick={() => {
                                    clearSessionCookie();
                                    window.location.href = '/login'
                                }} className={s.link}><RiLogoutBoxLine/>{' '}Logout</span>
                            </SidebarItem>
                        </div>
                    </div>
                }
            </div>
        </aside>
        <main className={`${sidebarShown ? s.mainSectionDisabled : s.mainSection}`} onScroll={handleScroll}>
            <Header leftNav={leftNav} title={title} onMenuClick={() => setSidebarShown(true)} placeholder={placeholder}
                    search={search}
                    searchBarSuggestions={searchBarSuggestions}
                    onSearchQueryChange={onSearchQueryChange}
                    onSearch={onSearch}
                    isScrolled={isScrolled}/>
            <div className={s.mainSectionContent}>
                {props.children}
            </div>
        </main>
    </div>
}

export default (SideBarContainer);
